<section class="mt-4 mb-5 agenda">
    <div class="container agenda-section-container">
        <div class="row" *ngIf="isAgendaObjectEmpty">
            <div class="col-md-12 head">
                <div class="mr-auto">
                    <h4><img src="/assets/images/agenda-icon.png" alt="Agenda">Agenda</h4>
                    <h4>No Records Found.</h4>
                </div>
            </div>
        </div>
        <div *ngIf="!isAgendaObjectEmpty">
            <div class="row">
                <div class="col-md-12 head">
                    <div class="mr-auto">
                        <h4><img src="/assets/images/agenda-icon.png" alt="Agenda">Agenda<span>({{ count
                                }})</span>:</h4>
                    </div>
                    <div class="view-toggle-btns">
                        <button class="view-toggle-btn" [class.view-toggle-active]="viewMode === 'grid'" (click)="setViewMode('grid')" title="Grid View">
                            <i class="fa fa-th-large"></i>
                        </button>
                        <button class="view-toggle-btn" [class.view-toggle-active]="viewMode === 'list'" (click)="setViewMode('list')" title="List View">
                            <i class="fa fa-list"></i>
                        </button>
                    </div>

                </div>
            </div>

            <!-- Grid View -->
            <div class="row" *ngIf="viewMode === 'grid'">
                <div class="col-12 col-md-6 col-lg-3 mt-4" *ngFor="let agenda of agendaObject; let i = index;">
                    <div class="box" *ngIf="agenda.isPublished">
                        <div class="srNo" style="cursor: pointer;" (click)="openAgendaItem(agenda)">{{agenda.AgendaNumber}}</div>
                        <strong *ngIf="agenda.isPublished">
                            <h5 style="cursor: pointer;" (click)="openAgendaItem(agenda)">{{agenda.AgendaTitle}}</h5>
                        </strong>
                        <div class="attach" *ngIf="agenda.isPublished">
                        </div>

                        <!-- Voting Section -->
                        <div class="agenda-voting-card-section" style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #e0e0e0;">
                          <!-- Loading State -->
                          <div *ngIf="votingLoading[agenda._id]" class="text-center" style="padding: 10px;">
                            <i class="fa fa-spinner fa-spin"></i> Loading...
                          </div>

                          <!-- Error State -->
                          <div *ngIf="votingError[agenda._id] && !votingLoading[agenda._id]" class="text-danger small" style="padding: 5px;">
                            {{votingError[agenda._id]}}
                          </div>

                          <!-- Voting UI -->
                          <div *ngIf="!votingLoading[agenda._id] && !votingError[agenda._id]">
                            <!-- Vote Buttons -->
                            <div style="display: flex; gap: 5px; margin-bottom: 10px;">
                              <button
                                type="button"
                                class="btn btn-sm flex-fill"
                                [ngClass]="getUserVote(agenda._id)?.voteType === 'APPROVE' ? 'btn-success' : 'btn-outline-success'"
                                (click)="submitVote(agenda, 'APPROVE'); $event.stopPropagation();"
                                title="Approve this agenda"
                                style="font-size: 11px; padding: 5px 8px;">
                                <i class="fa fa-check"></i>
                                <span *ngIf="getUserVote(agenda._id)?.voteType === 'APPROVE'">Approved</span>
                                <span *ngIf="getUserVote(agenda._id)?.voteType !== 'APPROVE'">Approve</span>
                              </button>

                              <button
                                type="button"
                                class="btn btn-sm flex-fill"
                                [ngClass]="getUserVote(agenda._id)?.voteType === 'REJECT' ? 'btn-danger' : 'btn-outline-danger'"
                                (click)="submitVote(agenda, 'REJECT'); $event.stopPropagation();"
                                title="Reject this agenda"
                                style="font-size: 11px; padding: 5px 8px;">
                                <i class="fa fa-times"></i>
                                <span *ngIf="getUserVote(agenda._id)?.voteType === 'REJECT'">Rejected</span>
                                <span *ngIf="getUserVote(agenda._id)?.voteType !== 'REJECT'">Reject</span>
                              </button>
                            </div>

                            <!-- Vote Counts -->
                            <div style="display: flex; justify-content: center; align-items: center; font-size: 11px; color: #666;">
                              <span class="text-success" style="margin-right: 10px;" title="Approve votes">
                                <i class="fa fa-thumbs-up"></i> {{getVoteCounts(agenda._id).approveCount}}
                              </span>
                              <span class="text-danger" title="Reject votes">
                                <i class="fa fa-thumbs-down"></i> {{getVoteCounts(agenda._id).rejectCount}}
                              </span>
                              <span *ngIf="getVoteCounts(agenda._id).totalVotes > 0" style="margin-left: 5px; color: #999; font-size: 10px;">
                                ({{getVoteCounts(agenda._id).totalVotes}} total)
                              </span>
                            </div>

                            <!-- Retract Button (only shown if user has voted) -->
                            <div *ngIf="hasUserVoted(agenda._id)" style="text-align: center; margin-top: 5px;">
                              <button
                                type="button"
                                class="btn btn-sm btn-link"
                                (click)="retractVote(agenda._id); $event.stopPropagation();"
                                style="font-size: 10px; padding: 2px 5px; text-decoration: underline; color: #007bff;">
                                Retract Vote
                              </button>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- List View -->
            <div class="ma-agenda-list-wrap mt-3" *ngIf="viewMode === 'list'">
                <ul class="ma-agenda-list">
                    <ng-container *ngFor="let agenda of agendaObject; let i = index;">
                        <li *ngIf="agenda.isPublished" class="ma-agenda-list-li">
                            <div class="ma-agenda-item-row">
                                <button type="button" class="ma-agenda-item-btn"
                                    (click)="openAgendaItem(agenda)">
                                    <span class="ma-agenda-index-box">{{agenda.AgendaNumber}}</span>
                                    <span class="ma-agenda-title">{{agenda.AgendaTitle}}</span>
                                    <span class="ma-agenda-attach">
                                        <i class="fa fa-paperclip" aria-hidden="true"></i>
                                        <span>{{agenda.AgendaGenerationPdf?.length || 0}}</span>
                                    </span>
                                </button>
                                <div class="ma-agenda-vote-row" *ngIf="!votingLoading[agenda._id] && !votingError[agenda._id]">
                                    <button type="button" class="btn btn-sm ma-vote-btn"
                                        [ngClass]="getUserVote(agenda._id)?.voteType === 'APPROVE' ? 'btn-success' : 'btn-outline-success'"
                                        (click)="submitVote(agenda, 'APPROVE'); $event.stopPropagation();"
                                        title="Approve">
                                        <i class="fa fa-check"></i>
                                        <span *ngIf="getUserVote(agenda._id)?.voteType === 'APPROVE'"> Approved</span>
                                        <span *ngIf="getUserVote(agenda._id)?.voteType !== 'APPROVE'"> Approve</span>
                                    </button>
                                    <button type="button" class="btn btn-sm ma-vote-btn"
                                        [ngClass]="getUserVote(agenda._id)?.voteType === 'REJECT' ? 'btn-danger' : 'btn-outline-danger'"
                                        (click)="submitVote(agenda, 'REJECT'); $event.stopPropagation();"
                                        title="Reject">
                                        <i class="fa fa-times"></i>
                                        <span *ngIf="getUserVote(agenda._id)?.voteType === 'REJECT'"> Rejected</span>
                                        <span *ngIf="getUserVote(agenda._id)?.voteType !== 'REJECT'"> Reject</span>
                                    </button>
                                    <span class="ma-vote-count text-success" title="Approve votes">
                                        <i class="fa fa-thumbs-up"></i> {{getVoteCounts(agenda._id).approveCount}}
                                    </span>
                                    <span class="ma-vote-count text-danger" title="Reject votes">
                                        <i class="fa fa-thumbs-down"></i> {{getVoteCounts(agenda._id).rejectCount}}
                                    </span>
                                    <span *ngIf="getVoteCounts(agenda._id).totalVotes > 0" class="ma-vote-total">
                                        ({{getVoteCounts(agenda._id).totalVotes}} total)
                                    </span>
                                    <button *ngIf="hasUserVoted(agenda._id)" type="button" class="btn btn-sm btn-link ma-retract-btn"
                                        (click)="retractVote(agenda._id); $event.stopPropagation();">
                                        Retract
                                    </button>
                                </div>
                                <div *ngIf="votingLoading[agenda._id]" class="ma-vote-loading">
                                    <i class="fa fa-spinner fa-spin"></i>
                                </div>
                                <div *ngIf="votingError[agenda._id] && !votingLoading[agenda._id]" class="text-danger small ma-vote-error">
                                    {{votingError[agenda._id]}}
                                </div>
                            </div>
                        </li>
                    </ng-container>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- AgendaCompliance POPUP LIST -->
<div class="modal fade " id="agendasCompliancePopUp" style="padding:0;overflow-y:hidden" tabindex="-1" role="dialog"
    aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document" style="margin: 0;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="agendasCompliancePopUpLabel">
                    Agenda Compliances</h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                    <i class="fa fa-times"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="datatable-card-block">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="margin-bottom-50">
                                <div class="table-responsive">
                                    <table datatable [dtOptions]="dtOptionsOfAgendaCompliancePopUp"
                                        [dtTrigger]="dtTriggerAgendaCompliancePopUp"
                                        class="table table-hover compact cell-border nowrap stripe"
                                        id="agendaCompliancePopUpTable" style="cursor: pointer;width:100%">
                                        <thead>
                                            <tr>
                                                <th>Task Name</th>
                                                <th>Task Description</th>
                                                <th>Global/Company Specific</th>
                                                <th>Group Name</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let agendaCompliance of agendaCompliances">
                                                <td style="white-space: normal;">{{agendaCompliance.TaskName}}</td>
                                                <td style="white-space: normal;">{{agendaCompliance.TaskDescription}}
                                                </td>
                                                <td>
                                                    <span *ngIf="agendaCompliance.IsGlobal">Global</span>
                                                    <span *ngIf="!agendaCompliance.IsGlobal">Company Specific</span>
                                                </td>
                                                <td>{{agendaCompliance.GroupName}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-sm" data-dismiss="modal">
                    <i class="fa fa-times"></i>Close
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade modal-size-medium" id="agendaPdfUploadDialog" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="width: 60%;margin: auto;">
            <div class="modal-header">
                <h5 class="modal-title">
                    <i class="fa fa-upload"></i>
                    <span id="AgendaPdfUploadTitle"></span>
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="fa fa-times"></i>
                </button>
            </div>
            <div class="modal-body" style="border:1px solid #ccc;">
                <div class="col-md-12">
                    <div class="row collapse1">
                        <table class="table table-hover compact cell-border nowrap stripe" style="cursor: pointer;">
                            <thead>
                                <tr>
                                    <td style="border-top:0px !important;"> <span
                                            style="padding:10px 15px;background: #d8ebeb;font-weight: 600;letter-spacing: 1px;display: inline-block;">
                                            {{agendaGenerationNumber}} </span> </td>
                                </tr>
                                <tr>
                                    <th>Filename1111</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let agenda of AgendaFile; let count=index">
                                    <td tabindex="1" style="width: 70%;">
                                        {{agenda.PdfName}}
                                    </td>
                                    <td>
                                        <button type="button" class="btn-sm btn btn-warning"
                                            (click)="downloadDocumentFile(agenda.DocumentManagementID,agenda.FileType)">
                                            <span title="View"
                                                *ngIf="agenda.FileType == 'PDF' || agenda.FileType == 'pdf' "
                                                class="fa fa-eye"></span>
                                            <span title="Download"
                                                *ngIf="agenda.FileType != 'PDF' && agenda.FileType != 'pdf' "
                                                class="fa fa-download"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>